// @ts-check
import { initSchema } from '@aws-amplify/datastore';
import { schema } from './schema';

const BoolLike = {
  "NOTSURE": "NOTSURE",
  "TRUE": "TRUE",
  "FALSE": "FALSE"
};

const EmploymentBases = {
  "FULLTIME": "FULLTIME",
  "TEMPFULLTIME": "TEMPFULLTIME",
  "PARTTIME": "PARTTIME",
  "TEMPPARTTIME": "TEMPPARTTIME",
  "CONTRACT": "CONTRACT"
};

const PurchaseStages = {
  "RESEARCHING": "RESEARCHING",
  "VIEWING": "VIEWING",
  "OFFERMADE": "OFFERMADE",
  "OFFERACCEPTED": "OFFERACCEPTED"
};

const SectionTypes = {
  "QUESTIONS": "QUESTIONS",
  "UPLOAD": "UPLOAD"
};

const MortgageTypes = {
  "REFINANCE": "REFINANCE",
  "PURCHASE": "PURCHASE",
  "TOPUP": "TOPUP"
};

const ApplicationTypes = {
  "LANDLORD": "LANDLORD",
  "OWNHOME": "OWNHOME",
  "MOVINGHOME": "MOVINGHOME",
  "FIRSTTIME": "FIRSTTIME",
  "SECONDTIME": "SECONDTIME"
};

const PropertyTypes = {
  "DETACHED": "DETACHED",
  "SEMIDETACHED": "SEMIDETACHED",
  "TERRACE": "TERRACE",
  "APARTMENT": "APARTMENT",
  "FLAT": "FLAT",
  "SITE": "SITE"
};

const DebtTypes = {
  "CREDITCARD": "CREDITCARD",
  "STORECARD": "STORECARD",
  "LOAN": "LOAN",
  "OVERDRAFT": "OVERDRAFT",
  "BUSINESSLOAN": "BUSINESSLOAN"
};

const AssetTypes = {
  "SAVING": "SAVING",
  "INVESTMENT": "INVESTMENT"
};

const Frequencies = {
  "WEEKLY": "WEEKLY",
  "FORTNIGHTLY": "FORTNIGHTLY",
  "MONTHLY": "MONTHLY",
  "QUARTERLY": "QUARTERLY",
  "YEARLY": "YEARLY",
  "STATIC": "STATIC",
  "OCCASIONALLY": "OCCASIONALLY"
};

const EmploymentTypes = {
  "EMPLOYED": "EMPLOYED",
  "SELFEMPLOYED": "SELFEMPLOYED",
  "HOMEMAKER": "HOMEMAKER",
  "STUDENT": "STUDENT"
};

const PersonalTitles = {
  "MR": "MR",
  "MRS": "MRS",
  "MISS": "MISS",
  "DR": "DR"
};

const PersonalMaritalStatuses = {
  "SINGLE": "SINGLE",
  "COHABITING": "COHABITING",
  "MARRIED": "MARRIED",
  "REMARRIED": "REMARRIED",
  "SEPARATED": "SEPARATED",
  "DIVORCED": "DIVORCED",
  "WIDOWED": "WIDOWED"
};

const PersonalAccommodationSituations = {
  "OWNED": "OWNED",
  "RENTED": "RENTED",
  "RELATIVES": "RELATIVES",
  "OTHER": "OTHER",
  "TOGETHER": "TOGETHER"
};

const PropertyIntendedUses = {
  "FIRSTTIME": "FIRSTTIME",
  "MOVING": "MOVING",
  "BUYTOLET": "BUYTOLET",
  "HOLIDAYHOME": "HOLIDAYHOME"
};

const UploadStatuses = {
  "PENDING": "PENDING",
  "ACCEPTABLE": "ACCEPTABLE",
  "REJECTED": "REJECTED",
  "UPLOADING": "UPLOADING",
  "REVIEWING": "REVIEWING",
  "EXPIRED": "EXPIRED"
};

const ApplicationStages = {
  "SETUP": "SETUP",
  "APPLY": "APPLY",
  "TASKS": "TASKS",
  "CALCULATE": "CALCULATE",
  "SIGN": "SIGN",
  "PREAPPROVAL": "PREAPPROVAL",
  "APPROVAL": "APPROVAL",
  "CLOSING": "CLOSING",
  "PREAPPROVAL_EXTENDING": "PREAPPROVAL_EXTENDING",
  "APPROVAL_EXTENDING": "APPROVAL_EXTENDING"
};

const DynamicSectionStages = {
  "SETUP": "SETUP",
  "APPLY": "APPLY",
  "SIGN": "SIGN",
  "SIGN_ISSUE": "SIGN_ISSUE",
  "PREAPPROVAL": "PREAPPROVAL",
  "PREAPPROVAL_ISSUE": "PREAPPROVAL_ISSUE",
  "APPROVAL": "APPROVAL",
  "APPROVAL_ISSUE": "APPROVAL_ISSUE"
};

const SubmissionStages = {
  "APPLY": "APPLY",
  "SIGN": "SIGN",
  "PREAPPROVAL": "PREAPPROVAL",
  "APPROVAL": "APPROVAL"
};

const ApplicationStatuses = {
  "DELAYED": "DELAYED",
  "ACTIVE": "ACTIVE",
  "SUSPENDED": "SUSPENDED",
  "COMPLETED": "COMPLETED",
  "OFFLINE": "OFFLINE",
  "ESCALATED": "ESCALATED"
};

const IncomeSources = {
  "SALARY": "SALARY",
  "DRAWINGS": "DRAWINGS"
};

const BuildType = {
  "NEW": "NEW",
  "SECONDHAND": "SECONDHAND",
  "SELFBUILD": "SELFBUILD",
  "UNKNOWN": "UNKNOWN"
};

const OverlayItemTypes = {
  "TEXT": "TEXT",
  "CHECK": "CHECK",
  "SIGNKEVIN": "SIGNKEVIN"
};

const TemplateTypes = {
  "OVERLAID": "OVERLAID",
  "COPIED": "COPIED",
  "GENERATED": "GENERATED",
  "PERMALINK": "PERMALINK",
  "FILLED": "FILLED"
};

const ContactMethods = {
  "EMAIL": "EMAIL",
  "PHONE": "PHONE",
  "DONT": "DONT"
};

const InvitationTypes = {
  "APPLICANT1": "APPLICANT1",
  "APPLICANT2": "APPLICANT2"
};

const ReplyRequestTypes = {
  "PREAPPROVAL": "PREAPPROVAL",
  "APPROVAL": "APPROVAL"
};

const AppointmentTypes = {
  "CALL": "CALL",
  "VIDEO": "VIDEO"
};

const MortgageQualificationStatus = {
  "QUALIFIED": "QUALIFIED",
  "UNQUALIFIED": "UNQUALIFIED",
  "MAYBE": "MAYBE"
};

const MortgageActiveAgents = {
  "BROKER": "BROKER",
  "USER": "USER",
  "LENDER": "LENDER"
};

const ProgressViewState = {
  "AUTO": "AUTO",
  "COMPLETE": "COMPLETE",
  "HIDDEN": "HIDDEN"
};

const UploadAnalysisStatus = {
  "PENDING": "PENDING",
  "PROCESSING": "PROCESSING",
  "PROCESSED": "PROCESSED",
  "FAILED": "FAILED"
};

const Reactions = {
  "POSITIVE": "POSITIVE",
  "NEGATIVE": "NEGATIVE",
  "UNSURE": "UNSURE"
};

const UploadAnalysisType = {
  "BANK_STATEMENT": "BANK_STATEMENT",
  "CREDITCARD_STATEMENT": "CREDITCARD_STATEMENT",
  "PAYSLIP": "PAYSLIP",
  "LOAN_STATEMENT": "LOAN_STATEMENT",
  "MORTGAGE_STATEMENT": "MORTGAGE_STATEMENT",
  "EDS": "EDS"
};

const FiguresTestNames = {
  "INITIAL_MAX_LOANS_BY_LENDER": "INITIAL_MAX_LOANS_BY_LENDER",
  "USER_MAX_LOANS_BY_LENDER": "USER_MAX_LOANS_BY_LENDER"
};

const PrimaryGoals = {
  "MAX_LOAN_POSSIBLE": "MAX_LOAN_POSSIBLE",
  "BEST_MONTHLY_PAYMENT_ON_LOAN": "BEST_MONTHLY_PAYMENT_ON_LOAN",
  "LONGEST_FIXED_TERM_ON_LOAN": "LONGEST_FIXED_TERM_ON_LOAN"
};

const SecondaryGoals = {
  "OVERPAYMENT_ALLOWED": "OVERPAYMENT_ALLOWED"
};

const AdjustmentDirections = {
  "UP": "UP",
  "DOWN": "DOWN"
};

const WorkflowExecutionStatus = {
  "ACTIVE": "ACTIVE",
  "WAITING": "WAITING",
  "COMPLETED": "COMPLETED",
  "FAILED": "FAILED"
};

const WorkflowHistoryStatus = {
  "PENDING": "PENDING",
  "COMPLETED": "COMPLETED",
  "FAILED": "FAILED"
};

const WorkflowStepTypes = {
  "WAIT_UNTIL": "WAIT_UNTIL",
  "ADMIN_ACTION": "ADMIN_ACTION",
  "USER_ACTION": "USER_ACTION",
  "SYSTEM_ACTION": "SYSTEM_ACTION",
  "SYSTEM_EMAIL": "SYSTEM_EMAIL",
  "STOP_IF": "STOP_IF"
};

const SubmissionTypes = {
  "AIP": "AIP",
  "LOANOFFER": "LOANOFFER",
  "CLOSING": "CLOSING"
};

const UserProductStatuses = {
  "INCOMPLETE": "INCOMPLETE",
  "ACTIVE": "ACTIVE",
  "COMPLETE": "COMPLETE",
  "APPROVED": "APPROVED",
  "REJECTED": "REJECTED",
  "WITHDRAWN": "WITHDRAWN"
};

const ProductTypes = {
  "MORTGAGE": "MORTGAGE",
  "MORTGAGE_PROTECTION": "MORTGAGE_PROTECTION"
};

const UserProduct7Workflow7Task7For = {
  "USER": "USER",
  "ADMIN": "ADMIN"
};

const UserProduct7Workflow7Task7Status = {
  "PENDING": "PENDING",
  "DONE": "DONE",
  "EXPIRED": "EXPIRED",
  "BLOCKED": "BLOCKED"
};

const { PublicCouncils, PublicLenderRate, PublicVendor, PublicVendorDocument, AdminTextractedSections, AdminMortgageAIResponse, AdminPdfOverlayTemplate, AdminPdfOverlayTemplateItem, AdminLenderFiles, AdminBackendUsers, AdminBackendUserPageVisit, AdminLender, AdminEmails, AdminEmailReplyRequest, AdminEmailAttachments, AdminUserCalculations, AdminSystemToDo, AdminTextractedStatement, AdminMortgageAccountSettings, AdminMortgageTasks, AdminMortgageTaskComponent, AdminMortgageTaskToDo, AdminMortgageNotes, AdminMortgageStageTask, AdminMortgageStageNotifications, AdminMortgageStageNotified, AdminMortgageDocumentContent, AdminMortgageSettings, AdminLastViewedMortgage, AdminMortgageLenderTest, AdminMortgageFiguresTestFlow, AdminMortgageFiguresTest, AdminMortgageTestForMax, AdminMortgageTestForPass, AdminMortgageFastTest, AdminMortgageFiguresTestFast, AdminMortgageFiguresTestResult, AdminMortgageLenderTestPlaygroundTest, AdminMortgageSectionVerification, AdminMortgageUploadVerifiedPoint, AdminMortgageSectionVerificationNote, AdminMortgageSubmission, AdminMortgageProtectionInsurance, AdminMortgageEmailQueue, AppError, UserMortgageLenderTestQueue, UserMortgageSubmissionIssue, UserPdfId, UserMortgageAppointment, UserMortgageSubmission, UserMortgageQuery, UserMortgageMpiQuote, UserMortgage, UserMortgageInvitation, UserMortgageDocuments, UserMortgageProgress, UserMortgageProgressNotes, UserMortgageDynamicSection, UserMortgageUploadStatementBalance, UserMortgageUploads, UserMortgageRequirement, UserMortgageProperty, UserMortgageExisting, UserMortgageNeeds, UserMortgageSolicitor, UserMortgagePropertyOnMortgage, UserMortgageFiguresTest, UserMortgageWorkflowExecution, UserMortgageWorkflowHistory, UserApplicant, UserApplicantLastHere, UserApplicantCurrentAccount, UserApplicantBusinessCurrentAccount, UserApplicantTax, UserApplicantPersonal, UserApplicantIncome, UserApplicantFinancial, UserApplicantEmployment, UserApplicantEmploymentIncome, UserApplicantAsset, UserApplicantDebt, UserApplicantBusinessDebt, UserApplicantProperty, UserApplicantAlternateEmailAddresses, UserApplicantActivity, UserApplicantHealth, UserAccount, UserAccount7Product, UserProduct, UserProduct7MPI, UserProduct7Quote, UserProduct7Query, UserProduct7Submission, UserProduct7Printout, UserProduct7Workflow, UserProduct7Workflow7Fact, UserProduct7Workflow7Task, UserProduct7Workflow7EventLog, DateRange, WorkflowStep } = initSchema(schema);

export {
  PublicCouncils,
  PublicLenderRate,
  PublicVendor,
  PublicVendorDocument,
  AdminTextractedSections,
  AdminMortgageAIResponse,
  AdminPdfOverlayTemplate,
  AdminPdfOverlayTemplateItem,
  AdminLenderFiles,
  AdminBackendUsers,
  AdminBackendUserPageVisit,
  AdminLender,
  AdminEmails,
  AdminEmailReplyRequest,
  AdminEmailAttachments,
  AdminUserCalculations,
  AdminSystemToDo,
  AdminTextractedStatement,
  AdminMortgageAccountSettings,
  AdminMortgageTasks,
  AdminMortgageTaskComponent,
  AdminMortgageTaskToDo,
  AdminMortgageNotes,
  AdminMortgageStageTask,
  AdminMortgageStageNotifications,
  AdminMortgageStageNotified,
  AdminMortgageDocumentContent,
  AdminMortgageSettings,
  AdminLastViewedMortgage,
  AdminMortgageLenderTest,
  AdminMortgageFiguresTestFlow,
  AdminMortgageFiguresTest,
  AdminMortgageTestForMax,
  AdminMortgageTestForPass,
  AdminMortgageFastTest,
  AdminMortgageFiguresTestFast,
  AdminMortgageFiguresTestResult,
  AdminMortgageLenderTestPlaygroundTest,
  AdminMortgageSectionVerification,
  AdminMortgageUploadVerifiedPoint,
  AdminMortgageSectionVerificationNote,
  AdminMortgageSubmission,
  AdminMortgageProtectionInsurance,
  AdminMortgageEmailQueue,
  AppError,
  UserMortgageLenderTestQueue,
  UserMortgageSubmissionIssue,
  UserPdfId,
  UserMortgageAppointment,
  UserMortgageSubmission,
  UserMortgageQuery,
  UserMortgageMpiQuote,
  UserMortgage,
  UserMortgageInvitation,
  UserMortgageDocuments,
  UserMortgageProgress,
  UserMortgageProgressNotes,
  UserMortgageDynamicSection,
  UserMortgageUploadStatementBalance,
  UserMortgageUploads,
  UserMortgageRequirement,
  UserMortgageProperty,
  UserMortgageExisting,
  UserMortgageNeeds,
  UserMortgageSolicitor,
  UserMortgagePropertyOnMortgage,
  UserMortgageFiguresTest,
  UserMortgageWorkflowExecution,
  UserMortgageWorkflowHistory,
  UserApplicant,
  UserApplicantLastHere,
  UserApplicantCurrentAccount,
  UserApplicantBusinessCurrentAccount,
  UserApplicantTax,
  UserApplicantPersonal,
  UserApplicantIncome,
  UserApplicantFinancial,
  UserApplicantEmployment,
  UserApplicantEmploymentIncome,
  UserApplicantAsset,
  UserApplicantDebt,
  UserApplicantBusinessDebt,
  UserApplicantProperty,
  UserApplicantAlternateEmailAddresses,
  UserApplicantActivity,
  UserApplicantHealth,
  UserAccount,
  UserAccount7Product,
  UserProduct,
  UserProduct7MPI,
  UserProduct7Quote,
  UserProduct7Query,
  UserProduct7Submission,
  UserProduct7Printout,
  UserProduct7Workflow,
  UserProduct7Workflow7Fact,
  UserProduct7Workflow7Task,
  UserProduct7Workflow7EventLog,
  BoolLike,
  EmploymentBases,
  PurchaseStages,
  SectionTypes,
  MortgageTypes,
  ApplicationTypes,
  PropertyTypes,
  DebtTypes,
  AssetTypes,
  Frequencies,
  EmploymentTypes,
  PersonalTitles,
  PersonalMaritalStatuses,
  PersonalAccommodationSituations,
  PropertyIntendedUses,
  UploadStatuses,
  ApplicationStages,
  DynamicSectionStages,
  SubmissionStages,
  ApplicationStatuses,
  IncomeSources,
  BuildType,
  OverlayItemTypes,
  TemplateTypes,
  ContactMethods,
  InvitationTypes,
  ReplyRequestTypes,
  AppointmentTypes,
  MortgageQualificationStatus,
  MortgageActiveAgents,
  ProgressViewState,
  UploadAnalysisStatus,
  Reactions,
  UploadAnalysisType,
  FiguresTestNames,
  PrimaryGoals,
  SecondaryGoals,
  AdjustmentDirections,
  WorkflowExecutionStatus,
  WorkflowHistoryStatus,
  WorkflowStepTypes,
  SubmissionTypes,
  UserProductStatuses,
  ProductTypes,
  UserProduct7Workflow7Task7For,
  UserProduct7Workflow7Task7Status,
  DateRange,
  WorkflowStep
};